import { useRouterState } from '@tanstack/react-router'

import { Button, Center, Heading, Text, VStack } from '@masterplandev/ui'

import { CloudinarySvgImage } from '@/cloudinary/CloudinarySvgImage'
import useTranslation from '@/core/hooks/useTranslation'
import { RouterLink } from '@/router/RouterLink'

export function NotFound() {
  const { translate } = useTranslation('router.not-found')
  const routerState = useRouterState()

  if (routerState.isLoading) {
    return null
  }

  return (
    <Center h="full" mt={20}>
      <VStack w="500px" gap={4}>
        <CloudinarySvgImage
          width="116px"
          height="100px"
          publicId="system/page-not-found.svg"
        />
        <Heading
          mt={4}
          textAlign="center"
          color="mp2.neutralLight.1000"
          fontSize="xl"
          lineHeight={7}>
          {translate('heading')}
        </Heading>
        <Text
          textAlign="center"
          color="mp2.neutralLight.700"
          lineHeight="18px"
          mb={4}>
          {translate('text')}
        </Text>
        <Button p={5} as={RouterLink} to="/company">
          {translate('button')}
        </Button>
      </VStack>
    </Center>
  )
}
